import { CONTENT_PLATFORM_PROPERTY_NAME, contentIsPublished, contentIsScheduled } from 'content-management-data-lib';
import { PublicAccessRuleTypes } from 'ui-memberships-settings-lib/constants/PublicAccessRuleTypes';
import { getContentIds } from './contentUtils';
const updatePropertiesOnCrmObject = (updatedProperties, crmObject, updatedDate) => {
  const updatedContentCrmObject = Object.assign({}, crmObject);
  const properties = Object.assign({}, updatedContentCrmObject.properties, updatedProperties, {
    [CONTENT_PLATFORM_PROPERTY_NAME.UPDATED_AT]: {
      value: `${updatedDate}`,
      rawValue: updatedDate
    }
  });
  updatedContentCrmObject.properties = properties;
  return updatedContentCrmObject;
};
export const updatePropertiesOnCrmObjects = (updatedProperties, crmObjects) => {
  const updatedDate = Date.now();
  const updatedObjectIds = getContentIds(crmObjects);
  return crmObjects.map(crmObject => {
    const updatedCrmObject = updatePropertiesOnCrmObject(updatedProperties, crmObject, updatedDate);
    if (updatedCrmObject.associatedObjects && updatedCrmObject.associatedObjects.OBJECT_TO_TRANSLATIONS) {
      const updatedAssociatedObjects = Object.assign({}, updatedCrmObject.associatedObjects);
      const updatedObjectToTranslations = updatedCrmObject.associatedObjects.OBJECT_TO_TRANSLATIONS.reduce((acc, translation) => {
        if (updatedObjectIds.includes(translation.objectId)) {
          const updatedTranslation = updatePropertiesOnCrmObject(updatedProperties, translation, updatedDate);
          acc.push(updatedTranslation);
        } else {
          acc.push(Object.assign({}, translation));
        }
        return acc;
      }, []);
      updatedAssociatedObjects.OBJECT_TO_TRANSLATIONS = updatedObjectToTranslations;
      updatedCrmObject.associatedObjects = updatedAssociatedObjects;
    }
    return updatedCrmObject;
  });
};
const getScheduledOrPublishedObjects = crmObjects => {
  return crmObjects.reduce((acc, crmObject) => {
    if (contentIsPublished(crmObject, true)) {
      acc.published.push(crmObject);
    }
    if (contentIsScheduled(crmObject, true)) {
      acc.scheduled.push(crmObject);
    }
    return acc;
  }, {
    scheduled: [],
    published: []
  });
};
const getPublishedAndOtherObjects = crmObjects => {
  return crmObjects.reduce((acc, crmObject) => {
    if (contentIsPublished(crmObject, true)) {
      acc.published.push(crmObject);
    } else {
      acc.scheduledOrDraft.push(crmObject);
    }
    return acc;
  }, {
    scheduledOrDraft: [],
    published: []
  });
};
export const publish = (crmObjects, scheduledDate) => {
  const newPublishDate = Date.now();
  if (scheduledDate) {
    const publishedAndOtherObjects = getPublishedAndOtherObjects(crmObjects);
    return [...updatePropertiesOnCrmObjects({
      [CONTENT_PLATFORM_PROPERTY_NAME.SCHEDULED_PUBLISH_DATE]: {
        value: `${scheduledDate}`,
        rawValue: scheduledDate
      },
      [CONTENT_PLATFORM_PROPERTY_NAME.RESOLVED_STATE]: {
        value: 'SCHEDULED_UPDATE',
        rawValue: 'SCHEDULED_UPDATE'
      }
    }, publishedAndOtherObjects.published), ...updatePropertiesOnCrmObjects({
      [CONTENT_PLATFORM_PROPERTY_NAME.SCHEDULED_PUBLISH_DATE]: {
        value: `${scheduledDate}`,
        rawValue: scheduledDate
      },
      [CONTENT_PLATFORM_PROPERTY_NAME.RESOLVED_STATE]: {
        value: 'SCHEDULED',
        rawValue: 'SCHEDULED'
      }
    }, publishedAndOtherObjects.scheduledOrDraft)];
  }
  return updatePropertiesOnCrmObjects({
    [CONTENT_PLATFORM_PROPERTY_NAME.PUBLISH_DATE]: {
      value: `${newPublishDate}`,
      rawValue: newPublishDate
    },
    [CONTENT_PLATFORM_PROPERTY_NAME.STATE]: {
      value: 'PUBLISHED',
      rawValue: 'PUBLISHED'
    },
    [CONTENT_PLATFORM_PROPERTY_NAME.RESOLVED_STATE]: {
      value: 'PUBLISHED',
      rawValue: 'PUBLISHED'
    }
  }, crmObjects);
};
export const changeAudienceAccess = (crmObjects, {
  accessRuleType,
  accessRuleIds,
  password
}) => {
  const publicAccessRuleIdsString = accessRuleIds.join(';');
  const updatedProperties = {
    [CONTENT_PLATFORM_PROPERTY_NAME.AUDIENCE_ACCESS_RULE_IDS]: {
      value: publicAccessRuleIdsString,
      rawValue: accessRuleIds
    },
    [CONTENT_PLATFORM_PROPERTY_NAME.AUDIENCE_ACCESS_RULE_TYPE]: {
      value: accessRuleType,
      rawValue: accessRuleType
    }
  };
  if (password) {
    updatedProperties[CONTENT_PLATFORM_PROPERTY_NAME.PASSWORD] = {
      value: password,
      rawValue: password
    };
    updatedProperties[CONTENT_PLATFORM_PROPERTY_NAME.AUDIENCE_ACCESS_RULE_TYPE] = {
      value: PublicAccessRuleTypes.PASSWORD,
      rawValue: PublicAccessRuleTypes.PASSWORD
    };
  }
  return updatePropertiesOnCrmObjects(updatedProperties, crmObjects);
};
export const unpublish = (crmObjects, scheduledDate) => {
  if (scheduledDate) {
    const scheduledOrPublishedObjects = getScheduledOrPublishedObjects(crmObjects);
    return [...updatePropertiesOnCrmObjects({
      [CONTENT_PLATFORM_PROPERTY_NAME.SCHEDULED_UNPUBLISH_DATE]: {
        value: `${scheduledDate}`,
        rawValue: scheduledDate
      },
      [CONTENT_PLATFORM_PROPERTY_NAME.RESOLVED_STATE]: {
        value: 'SCHEDULED_UNPUBLISH',
        rawValue: 'SCHEDULED_UNPUBLISH'
      }
    }, scheduledOrPublishedObjects.published), ...updatePropertiesOnCrmObjects({
      [CONTENT_PLATFORM_PROPERTY_NAME.SCHEDULED_UNPUBLISH_DATE]: {
        value: `${scheduledDate}`,
        rawValue: scheduledDate
      }
    }, scheduledOrPublishedObjects.scheduled)];
  }
  return updatePropertiesOnCrmObjects({
    [CONTENT_PLATFORM_PROPERTY_NAME.STATE]: {
      value: 'DRAFT',
      rawValue: 'DRAFT'
    },
    [CONTENT_PLATFORM_PROPERTY_NAME.RESOLVED_STATE]: {
      value: 'DRAFT',
      rawValue: 'DRAFT'
    }
  }, crmObjects);
};
export const archive = crmObjects => {
  return updatePropertiesOnCrmObjects({
    [CONTENT_PLATFORM_PROPERTY_NAME.ARCHIVED_IN_DASHBOARD]: {
      value: 'true',
      rawValue: true
    }
  }, crmObjects);
};
export const unarchive = crmObjects => {
  return updatePropertiesOnCrmObjects({
    [CONTENT_PLATFORM_PROPERTY_NAME.ARCHIVED_IN_DASHBOARD]: {
      value: 'false',
      rawValue: false
    }
  }, crmObjects);
};
export const assignPermissions = (crmObjects, permissionsInfo) => {
  const {
    teamIds,
    userIds
  } = permissionsInfo;
  return updatePropertiesOnCrmObjects({
    [CONTENT_PLATFORM_PROPERTY_NAME.TEAM_PERMS]: {
      value: teamIds.length > 0 ? teamIds.join(';') : 'null',
      rawValue: teamIds.length > 0 ? teamIds : null
    },
    [CONTENT_PLATFORM_PROPERTY_NAME.USER_PERMS]: {
      value: userIds.length > 0 ? userIds.join(';') : 'null',
      rawValue: userIds.length > 0 ? userIds : null
    }
  }, crmObjects);
};